import React, { createContext } from 'react';

const EmployeeContext = createContext({});

function EmployeeContextProvider({ children, value }) {
  return <EmployeeContext.Provider value={value}>{children}</EmployeeContext.Provider>;
}

export { EmployeeContext, EmployeeContextProvider };
